// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1Wt1C","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2wlJ0"};